/* eslint-disable react/prop-types */
import React, { useContext } from 'react';
import { useRouter } from 'next/router';
import Head from 'next/head';
import FooterTabs from '../footer/FooterTabs';
import Header from '../header/Header';
// import CallButton from '../right-bottom/CallButton';
import LeftSidebar from '../sidebar/LeftSidebar';
import { useUser } from '../../../contexts/ssr-user-context';
import { HeaderContext } from '../../../contexts/headerContext';
import ProfilePopup from '../../profile/ProfilePopup';
import Logout from '../logout';
import { getMetadata } from '../../../utils/metaDataTitle';
// import { useFirebase } from '../../../contexts/ssr-firebase-context';

function LayoutComponent({
  // eslint-disable-next-line no-unused-vars
  leftSidebarShow, pageTitle, headerType, children,
  paddingClass, pageName, headerMobileNotShow, isMobileWebView, headerClass, isShowFooterTabs = true,

}) {
  // const { getConfigValue } = useFirebase();
  // const webHomeMenus = getConfigValue('webHomeMenus');
  // const homePageData = getConfigValue('web_home_data');
  const { user } = useUser();
  const router = useRouter();
  // console.log('user', user);
  const { isMobile } = router.query;
  // const checkIsmobile = isMobile || false;
  const {
    showProfilePopup, setShowProfilePopup, showLogoutPopup, setShowLogoutPopup, headerData,
  } = useContext(HeaderContext);

  const closePopup = () => {
    setShowProfilePopup(!showProfilePopup);
  };
  const closeLogoutPopup = () => {
    setShowLogoutPopup(!showLogoutPopup);
  };
  const titlePage = headerData.headerTitle;
  let metadata;
  if (pageName) {
    metadata = '';
    metadata = getMetadata(pageName);
  } else {
    metadata = '';
    metadata = getMetadata(titlePage?.replace(/\s/g, ''));
  }

  return (
    <>
      <Head>
        <title>{metadata.title}</title>
      </Head>
      <div className="w-full flex justify-center">
        { showProfilePopup ? <ProfilePopup isVisible={showProfilePopup} onClose={closePopup} /> : '' }
        { showLogoutPopup ? <Logout isVisible={showLogoutPopup} onClose={closeLogoutPopup} /> : '' }
        {/* {console.log('isMobile ', isMobile, 'isShowFooterTabs ', isShowFooterTabs)} */}
        {(!isMobile && isShowFooterTabs)
          ? <FooterTabs isLoading={false} userInfo={user} /> : ''}

        <div className={`w-full flex flex-col items-center ${headerClass}`}>
          <div
            className="w-full shadow-md md:bg-gray sticky bg-white top-0 z-50"
          >
            {headerMobileNotShow || isMobileWebView // hide heder only in webview
              ? (
                <div className="hidden lg:block">

                  <Header logoShow="1" userInfo={user} />
                </div>
              )
              : <Header logoShow="1" userInfo={user} />}

          </div>
          <section className="w-full flex justify-center container">
            {/* Sidebar */}
            {leftSidebarShow
               && (
               <div className="lg:w-[18%] lg:sticky lg:top-[56px] lg:min-w-[240px] lg:pr-7 lg:h-screen lg:mt-4">
                 {/* sm:px-2 */}
                 <div className="hidden lg:block ">
                   <LeftSidebar user={user} />
                 </div>
               </div>
               )}
            {/* Main Content */}
            <div className={`${leftSidebarShow ? 'w-full lg:w-[80%]' : 'w-full'}`}>

              <div className={`main sm:${paddingClass}`}>
                {/* {pageName === 'courseDetail'
                  ? <CallButton phoneNumber={remoteConfigData?.homePageData?.phoneNumber} />
                  : ''} */}

                {children}
              </div>

              <div className={`${pageTitle === 'Slot Booking' ? 'mb-0' : 'mb-20'}`}>
                {/* Popular Videos */}
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
}

export default LayoutComponent;
